<template>
    <div class="network-issues">
        <h1>Упс, скорее всего у Вас проблемы с сетью.</h1>
    <p>Пожалуйста вернитесь на главную и попробуйте с начала.</p>
    <router-link class="home-link" :to="{ name: 'home' }"
      >На главную</router-link
    >
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
.network-issues {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 80vh;
}

.home-link {
  margin: 2rem 0;
  font-weight: 700;
  font-size: 2rem;
  color: #36429e;
}
</style>